import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
    selector: 'sui-panel',
    template: require('./sui.panel.component.html'),

})
export class PanelComponent  {
    @Input() headerText: string;
    @Input() headerClass: string;
    @Input() headerStyle: Object = {};
    @Input() headerIcon: string;
    @Input() panelClass: string;
    @Input() panelStyle: Object = {};
    @Input() closable = true;

    isClosed: boolean = false;
    onClose(event: any) {
        this.isClosed = true;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/sui/sui.panel/sui.panel.component.ts